import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { CircularProgress, FormControl, FormLabel } from '@mui/material';
import { t } from 'i18next';
import { BLUE_GRAY_200, PRIMARY } from '../../constants/Colors';

const filter = createFilterOptions<any>();

interface BakeasySelectAutoCompleteProps {
  key?: any;
  inputValue?: string;
  options?: any;
  value?: string;
  values?: string[] | undefined;
  label?: string;
  disabled?: boolean;
  multiple?: boolean;
  placeholder?: any;
  onChange: (newValue: any) => void;
  onAddClick?: (props: any) => void;
  required?: any;
}

export function BakeasyAutoCompleteTax(props: BakeasySelectAutoCompleteProps) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<any>(
    props?.options ? props?.options : []
  );
  const loading = open && options?.length === 0;

  let newTax: any = { id: 0, name: t('ADD_NEW_TAX'), namee: 'Add New Tax' };
  let na: any = { id: 1, taxName: t('NOT_APPLICABLE') };

  function setOption() {
    let newOptions: {}[] =
      props?.options && props?.options?.length > 0 ? props?.options : [];
    setOptions(newOptions);
  }

  React.useEffect(() => {
    setOption();
  }, [props?.options]);

  return (
    <React.Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props?.label) : ''}
          {props?.required ? ' *' : ''}
        </FormLabel>
        <Autocomplete
          id={props?.label ? t(props.label) : t('TAX1')}
          size="small"
          value={props?.value || null}
          disabled={props?.disabled ?? false}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: BLUE_GRAY_200, borderRadius: 2 },
              '&:hover fieldset': { borderColor: BLUE_GRAY_200 },
              '&.Mui-focused fieldset': {
                borderColor: PRIMARY,
                borderWidth: 1.5,
              },
            },
          }}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          filterOptions={(options: any, params: any) => {
            const filtered = filter(options, params);
            if (!filtered?.includes(newTax)) {
              filtered.push(newTax);
            }
            if (!filtered?.includes(na)) {
              filtered.push(na);
            }

            return filtered;
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (typeof value === 'string' && value?.length !== 0) {
              return true;
            }
            return option?.taxName === value?.taxName;
          }}
          getOptionLabel={(option: any) => {
            if (option?.taxName) {
              return option?.taxName;
            }
            if (option?.name) {
              return option?.name;
            }
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                // placeholder={props?.label ? t('SELECT') + ' ' + t(props?.label) : ''}
                placeholder={
                  props.placeholder ? props?.placeholder : t(props?.label || '')
                }
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 0) {
              props?.onChange(value);
            }

            if (typeof value === 'string' && value?.length === 0) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue: any) => {
            if (
              typeof newValue === 'object' &&
              newValue?.id === 0 &&
              newValue?.namee === 'Add New Tax'
            ) {
              if (props?.onAddClick) {
                props?.onAddClick(newValue);
              }
              return;
            }

            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </React.Fragment>
  );
}

export function BakeasyAutoCompleteShippingMethod(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<any>(
    props?.options ? props?.options : []
  );
  const loading = open && options.length === 0;

  let newShippingMethod: any = { id: 0, name: 'Add New Shipping Method' };

  function setOption() {
    let newOptions: {}[] =
      props?.options && props?.options?.length > 0 ? props?.options : [];
    setOptions(newOptions);
  }

  React.useEffect(() => {
    setOption();
  }, [props?.options]);

  return (
    <React.Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('SHIPPING_METHOD')}
          {' *'}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props?.value || null}
          disabled={props?.disabled ?? false}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: BLUE_GRAY_200, borderRadius: 2 },
              '&:hover fieldset': { borderColor: BLUE_GRAY_200 },
              '&.Mui-focused fieldset': {
                borderColor: PRIMARY,
                borderWidth: 1.5,
              },
            },
          }}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            if (!filtered?.includes(newShippingMethod)) {
              filtered.push(newShippingMethod);
            }

            return filtered;
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            return option?.shippingMethodName === value?.shippingMethodName;
          }}
          getOptionLabel={(option: any) => {
            if (option?.shippingMethodName) {
              return option?.shippingMethodName;
            }
            if (option?.name) {
              return option?.name;
            }
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT') + t('SHIPPING_METHOD')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 2) {
              props?.onChange(value);
            }

            if (typeof value === 'string' && value?.length === 0) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue: any) => {
            if (
              typeof newValue === 'object' &&
              newValue?.id === 0 &&
              newValue?.name === 'Add New Shipping Method'
            ) {
              if (props?.onAddClick) {
                props?.onAddClick(newValue);
              }
              return;
            }

            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </React.Fragment>
  );
}
